import { FC } from 'react';

export type SidebarSubtitleProps = {
  subtitle?: string;
};

export const SidebarSubtitle: FC<SidebarSubtitleProps> = ({ subtitle }) => (
  <div className="my-1 px-2 py-3 text-base font-semibold">{subtitle}</div>
);
